/**
 *
 * @param {string} dateStr
 * @return {string | null}
 */
export function formatDate(dateStr: string): string {
  if (!dateStr) {
    return "";
  }

  const parts = dateStr?.split("/");

  if (parts.length === 3) {
    const fecha = new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]));
    const year = fecha.getFullYear();
    const month = `0${fecha.getMonth() + 1}`.slice(-2);
    const day = `0${fecha.getDate()}`.slice(-2);

    return `${year}-${month}-${day}`;
  } else {
    return "";
  }
}
